/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Stats, StatsInterface } from "../Stats";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMajorType",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMajorValue",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMinorType1",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMinorType2",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMinorValue1",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMinorValue2",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rarityToTiers",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "statIdToStatName",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tierToStatBase",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Stats__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Stats> {
    return super.deploy(overrides || {}) as Promise<Stats>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Stats {
    return super.attach(address) as Stats;
  }
  connect(signer: Signer): Stats__factory {
    return super.connect(signer) as Stats__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StatsInterface {
    return new utils.Interface(_abi) as StatsInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Stats {
    return new Contract(address, _abi, signerOrProvider) as Stats;
  }
}
